import styled from 'styled-components';

export const JobFormWrapper = styled.div`
  margin-top: 16px;
  .ant-form-item {
    width: 288px;
  }

  & > div:first-child {
    margin-bottom: 16px;
  }
`;

export const DeleteContainer = styled.div<{ isIcon: boolean }>`
  display: flex;
  ${({ isIcon }) =>
    isIcon &&
    `
    & > div:last-child {
        cursor: pointer;
        margin-left: 18px;
        margin-top: 7px;
    }
  `}
`;

export const FormListContent = styled.div<{ isIcon: boolean }>`
  width: fit-content;
  display: flex;
  flex-direction: column;

  & > div:last-child {
    align-self: flex-end;
    margin-right: ${({ isIcon }) => (isIcon ? '41px' : 0)};
    .ant-btn {
      padding: 0;
    }
  }
`;

export const MainContainer = styled.div`
  margin: 16px 0;
  & > div:first-child {
    margin-bottom: 16px;
  }
`;
